var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product_banner"},[_c('div',{staticClass:"banner_info"},[_c('h3',[_vm._v("产品中心")]),_c('p',[_vm._v("一物一码 全流程 全追溯 全细节")])])])}]

export { render, staticRenderFns }